import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Fix for background tab throttling: prevents animations from "jumping" 
// when the user returns to the tab after a long period.
gsap.ticker.lagSmoothing(1000, 16);

// Ensure ScrollTrigger positions are recalculated when the tab regains focus.
window.addEventListener('focus', () => {
  ScrollTrigger.refresh();
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);